<template>
  <div class="login-page" :style="containerStyle">
    <div class="login-container">
      <!-- الشعار -->
      <img :src="logoImg" alt="Logo" class="mainlogo" />

      <!-- العنوان -->
      <h1 class="main-title">Welcome Back</h1>
      <p class="sub-title">Please enter your username and password</p>

      <!-- رسالة الخطأ -->
      <div v-if="invalidUserOrPassword" class="alert-error">
        {{ errorMsg }}
      </div>

      <!-- النموذج -->
      <form @submit.prevent="Login">
        <div class="form-group">
          <label for="username">Username</label>
          <input
            type="text"
            id="username"
            name="username"
            class="form-control"
            placeholder="Enter username"
            v-model="username"
            @focus="clearErrorMsg"
            required
          />
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            class="form-control"
            placeholder="Enter password"
            v-model="password"
            @focus="clearErrorMsg"
            required
          />
        </div>

        <div class="form-group">
          <label for="machine">Machine</label>
          <select
            id="machine"
            name="machine"
            class="form-control2"
            v-model="machine"
            required
          >
            <option value="0" hidden>Select Machine</option>
            <option v-for="m in machines" :key="m.id" :value="m.ip">
              {{ m.name }}
            </option>
          </select>
        </div>

        <button type="submit" class="btn-login" :disabled="loading">
          {{ loading ? "Signing in..." : "Login" }}
        </button>
      </form>

      <div class="footer-text">
        <span>Powered By: VIA UNiFi INFORMATION TECHNOLOGY</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import logoImg from "@/assets/viaerpwhite.png";
import loginBg from '@/assets/bgN.jpg'

export default {
  name: "Login",
  mixins: [commonServices],
  async mounted() {
    if (
      localStorage.userId !== undefined &&
      localStorage.userId !== "" &&
      localStorage.userId !== null
    ) {
      // If user session exists, go to dashboard (main landing page)
      this.$router.push({ name: "dashboard" });
    }
    this.language = "ar";
    this.handleLanguage();
    await this.getMachines();
    this.loginBg = loginBg;
    this.getThemeImage();
  },
  data() {
    return {
      username: "",
      password: "",
      machines: [],
      currentAppId: "",
      machine: 0,
      invalidUserOrPassword: false,
      errorMsg: "",
      logoImg: logoImg,
      loginBg: null,
      loading: false,
    };
  },
  methods: {
    clearErrorMsg() {
      this.invalidUserOrPassword = false;
      this.errorMsg = "";
    },

    async getMachines() {
      try {
        let dataURL = this.apiURL + "Modules/getMachines";
        let response = await axios.post(dataURL);
        if (response.data.status === "success") {
          this.machines = response.data.results;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getThemeImage() {
      try {
        let dataURL = this.apiURL + "ThemeImages/getThemeImage?key=login_image";
        let response = await axios.get(dataURL);
        if (response.data.status === "success" && response.data.data && response.data.data.Image) {
           // Assuming apiURL ends with 'api/', remove it to get base URL
           let baseURL = this.apiURL.replace('api/', '');
           this.loginBg = baseURL + response.data.data.Image;
        }
      } catch (error) {
        console.error("Error loading theme image:", error);
      }
    },

    goMain() {
      this.$router.push({ name: "dashboard" });
    },

    async Login() {
      if (this.machine == 0) {
        this.showAlert("Please Choose A Machine");
        return;
      }
      
      this.loading = true;
      this.clearErrorMsg();

      try {
        //Login With Last InvoiceId API
        let dataURL = this.apiURL + "Login";
        let loginJson = {
          action: "login",
          username: this.username,
          password: this.password,
        };
        let response = await axios.post(dataURL, loginJson);
        if (response.data.status === "success") {
          this.currentAppId = response.data.results.appId;
          localStorage.appId = response.data.results.appId;
          localStorage.userId = response.data.results.userId;
          localStorage.username = this.username;
          // persist user permissions so they survive page refresh
          try {
            localStorage.userPermissions = JSON.stringify(
              response.data.results.permissions || []
            );
          } catch (e) {}
          localStorage.return_ok = response.data.results.return_ok;
          localStorage.reports_ok = response.data.results.reports_ok;
          localStorage.pos_ok = response.data.results.pos_ok;
          localStorage.setItem("ip", this.machine);
          localStorage.setItem(
            "dsn",
            this.machines[
              this.machines.findIndex((el) => el.ip == this.machine)
            ].dsn
          );
          this.$store.commit(
            "modules_options/SET_USER_PERMISSIONS",
            response.data.results.permissions
          );
          this.$store.commit("SET_INITITAL_DATA", {
            prefix_barcode_qty: response.data.results.prefix_barcode_qty,
            prefix_barcode_prc: response.data.results.prefix_barcode_prc,
            scale_barcode_length: response.data.results.scale_barcode_length,
            suffix_length: response.data.results.suffix_length,
            pesapal_on: response.data.results.pesapal_on,
            efris_link: response.data.results.efris_link,
            efris_on: response.data.results.efris_on,
          });
          await this.fetchSettings();
          this.goMain();
          this.$emit('close');
        } else {
          this.invalidUserOrPassword = true;
          this.errorMsg = "Invalid login! please try again";
        }
      } catch (error) {
        console.log(error);
        this.invalidUserOrPassword = true;
        this.errorMsg = "An error occurred. Please check your connection.";
      } finally {
        this.loading = false;
      }
    },

    async fetchSettings() {
      try {
        let dataURL = this.apiURL + 'Shared/getSetting';
        let response = await axios.post(dataURL);
        if (response.data.status === 'success') {
          let rows = response.data.rows?.[0] || {};
          localStorage.setItem('allow_sync', rows.allow_sync);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    containerStyle() {
        if (!this.loginBg) return {};
        return {
            backgroundImage: `url(${this.loginBg})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            minHeight: '100vh'
        };
    }
},
};
</script>

<style scoped>
/* الصفحة العامة */
.login-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  overflow: hidden;
  /* background: linear-gradient(135deg, #273fdc, #00adef, #1b5772); */
  font-family: "Poppins", sans-serif;
}

.login-container {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border-radius: 20px;
  padding: 30px 30px;
  width: 90%;
  max-width: 380px;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.25);
}

/* الشعار */
.login-page .mainlogo {
  width: 90px;
  height: auto;
  margin-bottom: 15px;
}

/* العنوان الكبير */
.login-page .main-title {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 8px;
  letter-spacing: 1px;
   margin-top: 0; 
}

/* الجملة التوضيحية */
.login-page .sub-title {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 25px;
  letter-spacing: 0.3px;
}

/* رسالة الخطأ */
.alert-error {
  background-color: rgba(149, 85, 85, 0.1);
  color: red;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid rgba(255, 0, 0, 0.2);
}

/* الحقول */
.login-page .form-group {
  margin-bottom: 20px;
  text-align: left;
}

.login-page .form-group label {
  color: #ffffff;
  font-weight: 500;
  margin-bottom: 6px;
  display: block;
}

.login-page .form-control {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: #000000;
  font-size: 14px;
  outline: none;
  transition: background 0.3s;
  box-sizing: border-box; 
}

.login-page .form-control::placeholder {
  color: #ffffff;
}

.login-page .form-control:focus {
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid #00adef;
}

/* Dropdown specific */
select.form-control2 {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: none;
  background: #5f94a9;
  color: #ffffff;
  border: 1px solid #fff;
  font-size: 14px;
  outline: none;
  transition: background 0.3s;
  box-sizing: border-box; 
  background-repeat: no-repeat;
  background-position: right 0.7rem top 100%;
  background-size: 1rem auto;
}

/* الزر */
.login-page .btn-login {
  width: 100%;
  background: rgba(255, 255, 255, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;
}

.login-page .btn-login:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.5);
  transform: scale(1.03);
}

.login-page .btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* النص السفلي */
.login-page .footer-text {
  /* position: absolute; User had absolute, but flex layout might be better relative */
  /* bottom: 20px; */
  margin-top: 30px;
  text-align: center;
  font-size: 14px;
  color: #ddd;
  width: 100%;
}

.login-page .footer-text span {
  color: #fff;
  font-weight: 600;
}
</style>